module.exports = __webpack_public_path__ + "img/0Q3A2361_L_BlackMatted.67ee0a90.jpg";